<template>
  <v-text-field
    v-bind="$attrs"
    :type="showPassword ? 'text' : 'password'"
    :append-icon="showPassword ? '$eye_cancel' : '$eye_open'"
    v-on="$listeners"
    @click:append="showPassword = !showPassword"
  >
    <slot v-for="(_, name) in $slots" :slot="name" :name="name" />
  </v-text-field>
</template>

<script>
export default {
  data() {
    return {
      showPassword: false,
    }
  },
}
</script>
